import React from 'react';

interface INichePhotoSvgProps {
  width?: number;
  height?: number;
}

export const NichePhotoSvg: React.FC<INichePhotoSvgProps> = ({
  width = 40,
  height = 40,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="8"
        y="14"
        width="24"
        height="16"
        rx="3"
        stroke="#4CAF50"
        strokeWidth="1.5"
        fill="none"
      />
      <circle
        cx="20"
        cy="22"
        r="4.5"
        stroke="#4CAF50"
        strokeWidth="1.5"
        fill="none"
      />
      <circle cx="20" cy="22" r="2" fill="#4CAF50" />
      <circle cx="26" cy="12" r="1.5" fill="#4CAF50" />
    </svg>
  );
};
